import request from '@/utils/request'


// 查询配置信息列表
export function listConfig(query) {
  return request({
    url: '/tram/tram-config/list',
    method: 'get',
    params: query
  })
}

// 查询配置信息分页
export function pageConfig(query) {
  return request({
    url: '/tram/tram-config/page',
    method: 'get',
    params: query
  })
}

// 查询配置信息详细
export function getConfig(data) {
  return request({
    url: '/tram/tram-config/detail',
    method: 'get',
    params: data
  })
}

// 新增配置信息
export function addConfig(data) {
  return request({
    url: '/tram/tram-config/add',
    method: 'post',
    data: data
  })
}

// 修改配置信息
export function updateConfig(data) {
  return request({
    url: '/tram/tram-config/edit',
    method: 'post',
    data: data
  })
}

// 删除配置信息
export function delConfig(data) {
  return request({
    url: '/tram/tram-config/delete',
    method: 'post',
    data: data
  })
}
